<template>
	<div class="enter registration cover">
		<!-- Outer -->
		<div class="enter__outer">

			<!-- Enter Inner -->
			<div class="enter__inner registration__enter-inner">
				<div class="main-logo registration__logo">
					<img class="main-logo__item" src="../../../assets/img/logo.png" alt="logo">
				</div>
			</div>
			<!-- Enter Inner End -->

			<!-- Enter Inner -->
			<div class="enter__inner">
				<form id="entry_form" class="enter-form registration__form" @submit.prevent="sendSMS">
					<input-phone :user="user" :placeholder="'Введите номер телефона'" required></input-phone>
					<input class="enter-form__button" type="submit" value="Получить SMS">
					<router-link :to="'/login'"><a class="enter-form__link">Я уже зарегистрирован</a></router-link>
					<p class="enter__text">Шаг 1 из 4</p>
				</form>
			</div>
			<!-- Enter Inner End -->

		</div>
		<!-- Outer End -->
		
		
		

	</div>
</template>
<script>
	import InputPhone from '@/components/InputPhone.vue'

	export default {
		name: 'FirstStep',
		components: {InputPhone},
		data() {
			return {
				user: {
					phone: ''
				}
			}
		},
		methods: {
			sendSMS() {
				if (this.phone < 12)
					return false

				this.$api.post('auth/sms/send-code', {
					phone: this.user.phone,
					_scenario: 'registration'
				}).then(() => {
					this.$storage.set('reg.phone', this.user.phone)

					this.$router.push({name: 'Two'})
				})
			}
		}
	}

</script>



// WEBPACK FOOTER //
// One.vue?03a76c18